import { Code } from './Code';

export class PreChat {
  public Name: string;
  public Phone: string;
  public Email: string;
  public Subject: string;
  public RegistrationNumber: string;
  public ContractNumber: string;
  public CompanyName: string;

  public ContractRegList: Code[];
  public SubjectList: Code[];
}



// WEBPACK FOOTER //
// ./src/app/models/PreChat.ts